// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"49d943a1","195":"315818fd","206":"15e686f1","421":"63a2c48e","480":"1419b47c","488":"27c4afd6","626":"e46cea51","704":"66e5401d","884":"6ce9b3ad"}[chunkId] + ".chunk.js";
};